/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UserTokenQueryRendererQueryVariables = {
    token: string;
};
export type UserTokenQueryRendererQueryResponse = {
    readonly userTokenValid: boolean | null;
};
export type UserTokenQueryRendererQuery = {
    readonly response: UserTokenQueryRendererQueryResponse;
    readonly variables: UserTokenQueryRendererQueryVariables;
};



/*
query UserTokenQueryRendererQuery(
  $token: String!
) {
  userTokenValid(token: $token)
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "kind": "ScalarField",
    "name": "userTokenValid",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserTokenQueryRendererQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserTokenQueryRendererQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0662b208e0f92859777d57f6ea95bed1",
    "id": null,
    "metadata": {},
    "name": "UserTokenQueryRendererQuery",
    "operationKind": "query",
    "text": "query UserTokenQueryRendererQuery(\n  $token: String!\n) {\n  userTokenValid(token: $token)\n}\n"
  }
};
})();
(node as any).hash = '5ff76480be6830b1ffd09e3602914a5e';
export default node;
